import { RESET_LOCATION_FORM } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default () => creditFileActions[RESET_LOCATION_FORM]();
